import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as dayjs from 'dayjs';

// constants defining the date reference for relative dates to the current date.  We are using the 01/Jan of the year used to denote 'today'
const currentDay = 1;
const currentMonth = 0;

export const TODAY_YEAR = 3001;
export const ONE_DAY = 24 * 60 * 60 * 1000;  // hours*minutes*seconds*milliseconds

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!value) {
      // MRD - if there is no date to display, we want to display a blank string
      //   return 'Undefined'; // - Try setting [min] and [max] values on the validation-errors tag';
      return '';
    }

    // check if value only contains numbers...
    // if it does then probably not a valid date, return the value 'as is'
    // if it does not then...
    // check if 'tdoay' string...
    // check if value is a valid date
    // if it is then use the default datepipe to convert to the required format
    // if it isn't then return the value 'as is'
    if (/^[-]?\d+$/.test(value.toString())) { return value; }
    if (/^t(?:oday)?[-+ ]*\d{0,3}$/.test(value.toString().toLowerCase())) { return value; }
    let d;
    if (dayjs.utc(value).isValid()) { d = dayjs.utc(value).add(1, 'hours'); }
    if (dayjs.utc(value, 'DD/MMM/YYYY').isValid()) { d = dayjs.utc(value, 'DD/MMM/YYYY').add(1, 'hours'); }
    if (d) {
      return (d.year() >= (TODAY_YEAR - 3)) ? this.relativeToToday(d) : d.format('DD/MMM/YYYY');
    }
    return value;
  }

  relativeToToday(d: dayjs.Dayjs): string {
    const today = dayjs(new Date(TODAY_YEAR, currentMonth, currentDay));
    const days = Math.round((d.valueOf() - today.valueOf()) / ONE_DAY);
    return `Today${(days === 0) ? '' : (((days > 0) ? '+' : '') + days.toString())}`;
  }
}

// tslint:disable-next-line:max-classes-per-file
@Pipe({
  name: 'timeFormat',
})
export class TimeFormatPipe extends DatePipe implements PipeTransform {
  transform(value: number, args?: any): any {
    // format an integer (count of seconds) and format correctly
    if (!value || value < 1) {
      return '';
    }

    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value % 60);
    let s = '';
    if (minutes > 0) {
      s = minutes.toString() + ' minute';
    }
    if (minutes > 1) {
      s = s + 's';
    }
    s = s + ' ';

    if (seconds > 0) {
      s = s + seconds.toString() + ' second';
    }
    if (seconds > 1) {
      s = s + 's';
    }
    return s;
  }
}
